import React, { useState, useEffect } from "react";

//MUI
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertColor } from "@mui/material/Alert";

import { useAppDispatch, useAppSelector } from "../redux/hooks/redux-hooks";
import { addDisplayToast, showToast } from "../redux/actions/ToastActions";

const ToastMsg = () => {
  const [isShow, setIsShow] = useState(false);

  const toastProps = useAppSelector((state) => state.toast);
  const dispatch = useAppDispatch();

  const handleToastClose = () => {
    setIsShow(false);
  };

  useEffect(() => {
    const displayToast = (msg: string, variant: AlertColor = "info") => {
      setIsShow(true);
      dispatch(
        showToast({
          variant: variant,
          msg: msg,
        })
      );
    };
    dispatch(addDisplayToast(displayToast));
  }, [dispatch]);

  return (
    <Snackbar
      open={isShow}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleToastClose}
    >
      <Alert onClose={handleToastClose} severity={toastProps.variant}>
        {toastProps.msg}
      </Alert>
    </Snackbar>
  );
};

export default ToastMsg;
